import { TRootState }                                   from 'Redux/Reducers';
import { filterObjectStore, queryFilter, IFilterProps } from 'Utils';
import { Organizer }                                    from 'Domain/Models';

export const getSearchedOrganizers = (state: TRootState, filter: null | IFilterProps<Organizer> = null) => {
  if (filter === null) {
    filter = queryFilter({ sorting: { by: 'id', order: 'ASC' } }) as IFilterProps<Organizer>;
  }

  return filterObjectStore(state.organizer.searchEntries, filter);
};
